import React from 'react'
import { 
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    CellFooter, Switch, Toast, Dialog, CellHeader, Label, Input, Toptips
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import {WKVisible} from '../../components/wk'
import '../../css/page/ChannelEditPage.css'


class ChannelEditPriorityPage extends React.Component {
    constructor (props) {
        super(props)
        this.type = /^\/lecture\//.test(props.location.pathname) ? 'lecture' : 'channel'
        this.state = {
            isPending: false,
            priority: 0,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/${this.type}/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({ 
                    priority: res.data.data[this.type].liveroom_priority,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        if (this.state.isInputError) {
            this.setState({ alertDialog: { isShow: false } })
        } else {
            browserHistory.go(-1)
        }
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    verify () {
        const priority = this.state.priority
        if (isNaN(+priority) || priority < 0) {
            return {
                status: false,
                msg: '优先级应该大于或等于0'
            }
        }
        return { status: true }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true })
        const field = this.type === 'lecture' ? 'liveroom_priority' : 'priority'
        axios.post(`/api/${this.type}/${this.props.params.id}/edit`, qs.stringify({
            [field]: this.state.priority,
        }))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.setState({
                    alertDialog: { isShow: true, text: '修改成功' }
                })
            })
    }
    render() {
        const typeName = this.type === 'lecture' ? '课程' : '专栏'
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="priority-page">
                        <Header title='选择课程优先级' />
                        <Form className='margin-bottom'>
                            <FormCell>
                                <CellHeader>
                                    <Label>优先级</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        type="number" 
                                        pattern='[0-9]*'
                                        placeholder="请输入优先级" 
                                        value={this.state.priority} 
                                        onChange={e => this.bindValue(e, 'priority')} 
                                        className='text-right'
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="intro sm">1. 数字越大代表{typeName}的优先级越高</p>
                        <p className="intro sm">2. 优先级越高的{typeName}，在讲师直播间排在越前</p>
                        <p className="intro sm margin-bottom">3. 当直播间{typeName}较多时，优先级高的{typeName}容易被更多人收听</p>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit()}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditPriorityPage


// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditPriorityPage.js